import { Clips } from '@air/api';
import { matchesAirror, NOT_FOUND } from '@air/errors';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import invariant from 'tiny-invariant';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const getPrivateTranscriptInfoKey = (clipId: string) => ['PRIVATE_CLIP_TRANSCRIPT_INFO', { clipId }];

export const useGetPrivateClipTranscriptInfo = ({ clipId, enabled }: { clipId: string; enabled: boolean }) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const key = useMemo(() => getPrivateTranscriptInfoKey(clipId), [clipId]);

  return useQuery({
    queryKey: key,

    queryFn: () => {
      const workspaceId = currentWorkspace?.id;
      invariant(workspaceId, 'Workspace ID is required to fetch transcript info');

      return Clips.getTranscript({ workspaceId, clipId });
    },
    enabled,
    retry: (failureCount, error) => {
      // if transcript is not found, we don't want to retry
      if (matchesAirror(error, NOT_FOUND)) {
        return false;
      }
      return failureCount < 3;
    },
  });
};
